import { formatPrice } from '@/utils/priceHelper'
import { TFunction } from 'i18next'

export const formatFreeOfChargeAblePrice = (
    price: { amount: string; currency: string },
    t: TFunction<'app'>,
    forceSign: boolean = false,
    precision?: number
): string => {
    return +price.amount
        ? formatPrice(price.amount, price.currency, forceSign, precision)
        : t('freeOfCharge')
}
